var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsEnvSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2328 7.46264C32.9012 4.13105 28.4699 2.30029 23.7604 2.30029C19.0444 2.30029 14.6195 4.13105 11.288 7.46264C7.95637 10.7942 6.11914 15.2256 6.11914 19.9351C6.11914 29.4641 15.1306 37.3952 19.976 41.6519C20.6488 42.247 21.2245 42.7581 21.6903 43.185C22.2725 43.7285 23.0164 44.0002 23.7604 44.0002C24.5043 44.0002 25.2483 43.7285 25.824 43.185C26.2898 42.7581 26.872 42.247 27.5448 41.6519C32.3837 37.3952 41.3952 29.4641 41.3952 19.9351C41.3952 15.2256 39.5644 10.7942 36.2328 7.46264Z",
    fill: "#E13827",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6335 15.232C32.1367 15.232 34.9738 14.9112 34.9738 14.5166L33.4442 13.1104C33.3702 13.2583 33.0743 13.3817 31.9639 13.5051C31.0758 13.6037 29.8917 13.6531 28.6334 13.6531C27.3752 13.6531 26.191 13.6037 25.3028 13.5051C24.1927 13.3817 23.8965 13.2337 23.8225 13.1104L22.293 14.5166C22.293 14.9114 25.1301 15.232 28.6332 15.232H28.6335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3205 13.0123C33.3205 13.2985 31.2219 13.5303 28.6332 13.5303C26.0443 13.5303 23.9458 13.2985 23.9458 13.0123C23.9458 12.7261 26.0444 12.4941 28.6332 12.4941C31.2219 12.4941 33.3205 12.7261 33.3205 13.0123Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1479 15.1586C31.939 15.3066 30.3353 15.3806 28.6332 15.3806C26.931 15.3806 25.3275 15.3066 24.1433 15.1832C24.0199 15.1586 23.8965 15.1586 23.7733 15.1338L22.293 16.4907C22.293 16.8855 25.13 17.206 28.6332 17.206C32.1364 17.206 34.9735 16.8853 34.9735 16.4907L33.4932 15.1338C33.3944 15.134 33.271 15.1586 33.1478 15.1586H33.1479Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5837 21.943C28.115 21.943 27.6956 21.9184 27.3502 21.8936C27.1282 21.869 26.9802 21.8442 26.9062 21.8196V29.0233C27.0049 29.0973 27.6216 29.1713 28.5837 29.1713C29.5459 29.1713 30.138 29.0727 30.2612 29.0233V21.7949C30.1626 21.8195 30.0392 21.8443 29.8173 21.8689C29.4719 21.9183 29.0277 21.9429 28.5837 21.9429V21.943Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5841 19.3524C27.6713 19.3524 26.8078 19.303 26.1417 19.2291C25.6977 19.1798 25.4509 19.1304 25.2783 19.0811L26.8818 21.6467C26.9558 21.7207 27.5726 21.7947 28.5593 21.7947C29.546 21.7947 30.1628 21.6961 30.2368 21.6467L31.8652 19.0811C31.7172 19.1304 31.4459 19.1797 31.0017 19.2291C30.3603 19.3032 29.4968 19.3524 28.584 19.3524H28.5841Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.584 29.2941C28.1152 29.2941 27.6958 29.2695 27.3505 29.2447C27.1777 29.2201 27.0545 29.1953 26.9805 29.1953L27.7206 30.5028V32.7725C27.7206 33.2165 28.0414 33.6112 28.4608 33.6606C28.9789 33.7346 29.4229 33.3153 29.4229 32.8219V30.5028L30.1631 29.2199C30.0645 29.2445 29.9657 29.2693 29.7931 29.2693C29.4721 29.2695 29.028 29.2941 28.584 29.2941L28.584 29.2941Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2041 17.2065V18.884C25.3521 19.0074 26.6104 19.2048 28.5839 19.2048C30.5576 19.2048 31.8156 19.032 31.9637 18.884V17.2065C30.9521 17.2805 29.7926 17.3299 28.5839 17.3299C27.3504 17.3299 26.1909 17.2805 25.2041 17.2065Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0085 21.0059C22.9345 21.0305 22.8851 21.0305 22.8111 21.0553C22.9345 21.4993 23.0085 22.042 23.0085 22.6588L19.2833 23.3495C19.2093 22.9795 18.8886 22.6834 18.4938 22.6834C18.3952 22.6834 18.2964 22.708 18.2224 22.7328L16.7421 20.1917C16.9395 19.8958 17.0875 19.5504 17.1121 19.1802C17.1861 18.2921 16.6681 17.4533 15.8539 17.1326C15.41 16.9598 14.9412 16.9352 14.5218 17.0586C14.6452 17.5767 14.7192 18.2181 14.7192 18.9335C14.7192 19.723 14.6206 20.4384 14.4725 20.9811C15.1386 21.1785 15.8046 21.0305 16.3227 20.6603L17.7782 23.152C17.7288 23.2754 17.6796 23.3988 17.6796 23.522V23.7934L15.0398 25.3476C15.0644 24.9529 15.1384 24.5829 15.2126 24.2621C15.1386 24.2375 15.0892 24.2127 15.0152 24.2127C13.9051 23.9659 12.795 24.7061 12.5728 25.841C12.3754 26.9017 13.091 27.9873 14.1517 28.2094C14.5217 28.2834 14.8919 28.2588 15.2124 28.1354C15.0644 27.5927 14.9657 26.8525 14.9657 26.0384L17.6301 24.4595V32.798C17.6301 33.2174 17.9508 33.6121 18.3702 33.6368C18.8636 33.6862 19.2583 33.2914 19.2583 32.8227L19.2585 23.9418L22.959 23.251C22.9344 23.8924 22.8604 24.4845 22.7123 24.9285C23.0576 25.0519 23.403 25.0765 23.773 25.0025C24.8337 24.7805 25.5493 23.7196 25.3519 22.6341C25.2287 21.4995 24.1431 20.7594 23.0084 21.006L23.0085 21.0059Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4517",
    x: 0.619141,
    y: 0.800293,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4517",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsEnvSensor);
export default __webpack_public_path__ + "static/media/alertsEnvSensor.d21da195847c72852572f666750a2038.svg";
export { ForwardRef as ReactComponent };